import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { Artifact, TYPE_COLORS, TYPE_LABELS, STATUS_COLORS, STATUS_LABELS } from './types';
import { ArtifactPreview } from './ArtifactPreview';
import { ArtifactActions } from './ArtifactActions';
interface ArtifactFullScreenProps {
  artifact: Artifact | null;
  onClose: () => void;
  onApprove?: () => void;
  onRefine?: (comment: string) => void;
  onDiscard?: () => void;
}
export function ArtifactFullScreen({
  artifact,
  onClose,
  onApprove,
  onRefine,
  onDiscard
}: ArtifactFullScreenProps) {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);
  return <AnimatePresence data-id="element-189">
      {artifact && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 bg-[#141418]/95 flex flex-col" onClick={onClose} data-id="element-190">
          <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="flex-1 flex flex-col max-w-[900px] w-full mx-auto p-6" onClick={e => e.stopPropagation()} data-id="element-191">
            {/* Header */}
            <div className="flex items-center justify-between mb-4" data-id="element-192">
              <div className="flex items-center gap-3" data-id="element-193">
                <span className="text-[12px]" style={{
              color: TYPE_COLORS[artifact.type]
            }} data-id="element-194">{TYPE_LABELS[artifact.type]}</span>
                <span className="text-[11px] px-2 py-0.5 rounded" style={{
              background: STATUS_COLORS[artifact.status].bg,
              color: STATUS_COLORS[artifact.status].text
            }} data-id="element-195">
                  {STATUS_LABELS[artifact.status]}
                </span>
              </div>
              <button onClick={onClose} className="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-white/5 transition-colors" data-id="element-196">
                <X size={18} className="text-[#8a8680]" data-id="element-197" />
              </button>
            </div>

            {/* Preview */}
            <div className="flex-1 min-h-0 rounded-xl overflow-hidden border border-white/[0.06]" data-id="element-198">
              <div className="w-full h-full" data-id="element-199">
                <ArtifactPreview artifact={artifact} data-id="element-200" />
              </div>
            </div>

            {/* Title + Description */}
            <div className="mt-4" data-id="element-201">
              <div className="text-[18px] text-[#e8e4df] font-medium" data-id="element-202">{artifact.title}</div>
              <div className="text-[14px] text-[#8a8680] mt-1" data-id="element-203">{artifact.description}</div>
            </div>

            {/* Actions */}
            <div className="mt-4" data-id="element-204">
              <ArtifactActions artifact={artifact} onApprove={() => {
            onApprove?.();
            onClose();
          }} onRefine={comment => {
            onRefine?.(comment);
            onClose();
          }} onDiscard={() => {
            onDiscard?.();
            onClose();
          }} data-id="element-205" />
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}